<template>
    <div class="start-new-imprint__section imprint-location">
        <label class="start-new-imprint__label" :for="getID">
            Imprint Location
        </label>
        <select
            :id="getID"
            class="start-new-imprint__selector form-control imprint-location"
            v-model="imprintLocationSelected"
            @change="setImprintLocation($event.target.value, $event)"
        >
            <option v-for="(option, arrIndex) in imprintData.imprint_position._imprints" :key="arrIndex"> 
                {{ option.title }}
            </option>
        </select>
    </div>
</template>

<script>
import { store } from './store.js';

export default {
    props: {
        cStep: Number
    },
    data() {
        return {
            debugMode: true,
            store: store,
            imprintData: {}, // configurable_2_data
            imprintLocationSelected: '',
            imprintLocationData: {
                value: null,
                sku: null
            }
        }
    },
    computed: {
        getID: function () {
            return 'imprint-location-' + this.cStep;
        }
    },
    methods: {
        sortItems() {
            this.imprintData.imprint_position._imprints.sort((a,b)=>{
                return a.sort - b.sort;
            });

            console.error("@@@@@@@@@@@@@@@@@ >>>>>> this.imprintData.imprint_position._imprints");
            console.log(this.imprintData.imprint_position._imprints);
        },
        initLocationDataFromStore() {
            this.imprintLocationSelected = this.imprintData.imprint_position._imprints[0].title;
            this.store.selectedLastStep[this.store.imprintKey].imprintLocation = this.imprintLocationSelected;
        },
        initLocationDataFromLastSavedState() {
            this.imprintLocationSelected = this.store.selectedLastStep[this.store.imprintKey].imprintLocation;
        },
        initCurrentImprintData() {
            console.error(">>>>>>>>> Imprint Location init >>>>>>");
            this.imprintSKU = this.store.selectedImprint.sku;
            this.store.sku.imprint.method.val = this.imprintSKU;
            this.imprintData = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].configurable_2_data;
            this.store.selectedImprint.data = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU];
            
            this.sortItems();

            if(!this.store.selectedLastStep[this.store.imprintKey].imprintLocation) {
                console.error(this.store);
                this.initLocationDataFromStore();
            } else {
                this.initLocationDataFromLastSavedState();
            }
        },
        setImprintLocation(value, event) {
            console.error("!!!!!!!!!!!! setImprintLocation");
            // TODO this.store.selectedLastStep[this.store.imprintKey].imprintLocation change to this.store.selectedLastStep[this.store.imprintKey]._imprintLocation
            this.store.selectedLastStep[this.store.imprintKey].imprintLocation = value;
            this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.value = value;
            this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.sku = event.target.selectedOptions[0].dataset.sku;
            this.store.sku.imprint.location.val = event.target.selectedOptions[0].dataset.sku;

            this.imprintLocationSelected = value;
            if(this.debugMode) {
                console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
                console.log(this.store.selectedLastStep[this.store.imprintKey]);
                console.log(event.target.dataSku);
                console.log(event.target.selectedOptions);
                console.log(event.target.selectedOptions[0].dataset.sku);
            }
        },
    },
    created() {
        this.initCurrentImprintData();
    }
}
</script>

<style>

</style>